<script setup lang="ts">
import ToastHost from '@/components/ds/ToastHost.vue'
import ConfirmHost from '@/components/ds/ConfirmHost.vue'
import MenuHost from '@/components/ds/MenuHost.vue'
</script>

<template>
  <router-view />
  <ToastHost />
  <ConfirmHost />
  <MenuHost />
</template>
